import ProgressiveImage from 'react-progressive-image';
import { assetUrl } from '../../../../utils/webConfig';
import { Wallet } from '../../../../api';
import { CARD_LOGO } from '../../../../components';

export type PaymentCardProps = {
    accountType: Wallet['type'];
    accountNumber: string;
    isPreferred?: boolean;
};

const getWalletAccountNumber = (number: string) =>
    number
        .replace(/\W/gi, '')
        .replace(/(.{4})/g, '$1 ')
        .trim();

export const PaymentCard: React.FC<PaymentCardProps> = ({
    accountType,
    accountNumber,
    isPreferred,
}) => {
    const type = accountType.toLowerCase();
    const logoSrc = CARD_LOGO[type];
    const cardSrc = assetUrl(
        `/images/svg/${type.replace(' ', '_')}-card.svg?v=2`,
    );

    return (
        <div
            data-testid="payment-card"
            className={`relative rounded-lg overflow-hidden shadow-[0_6px_12px_0_rgba(0,64,128,0.19)]${!isPreferred ? ' opacity-80' : ''}`}
        >
            {/* @ts-ignore */}
            <ProgressiveImage
                src={cardSrc}
                placeholder={assetUrl('/images/svg/default-card.svg')}
            >
                {(src: any, loading: any) => (
                    <img
                        data-testid="card-image"
                        className="w-full block"
                        src={loading ? src : assetUrl(src)}
                        alt=""
                    />
                )}
            </ProgressiveImage>
            {logoSrc && (
                <img
                    data-testid="card-logo"
                    className="absolute top-5 left-5"
                    src={assetUrl(logoSrc)}
                    alt={accountType}
                />
            )}
            <span
                data-testid="card-number"
                className="absolute bottom-5 left-5 text-white text-body-small"
            >
                {getWalletAccountNumber(accountNumber)}
            </span>
        </div>
    );
};
